import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {API_BASE_URL} from "../config";

export default function BookingDetails() {
    const { id } = useParams();
    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/bookings/${id}`)
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error("Booking not found");
                }
                return res.json();
            })
            .then((data) => {
                setBooking(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <p className="p-6 text-[#023059]">Loading booking details...</p>;
    if (error) return <p className="p-6 text-red-600 font-semibold">{error}</p>;

    return (
        <div className="max-w-3xl mx-auto bg-white rounded-xl p-8 shadow-md border border-[#1D4E80] mt-8">
            <h1 className="text-3xl font-bold text-primarymb-6">Booking Details</h1>

            <div className="space-y-4 text-[#023059]">
                <p>
                    <span className="font-semibold">Name:</span> {booking.full_name || booking.name}
                </p>
                <p>
                    <span className="font-semibold">Email:</span> {booking.email}
                </p>
                {booking.company && (
                    <p>
                        <span className="font-semibold">Company:</span> {booking.company}
                    </p>
                )}
                <p>
                    <span className="font-semibold">Hotel:</span> {booking.hotel}
                </p>
                <p>
                    <span className="font-semibold">Start Date:</span>{" "}
                    {new Date(booking.start_date).toLocaleDateString()}
                </p>
                <p>
                    <span className="font-semibold">End Date:</span>{" "}
                    {new Date(booking.end_date).toLocaleDateString()}
                </p>
                <p>
                    <span className="font-semibold">Guests:</span> {booking.guests}
                </p>
                {booking.notes && (
                    <p>
                        <span className="font-semibold">Notes:</span> {booking.notes}
                    </p>
                )}
            </div>
        </div>
    );
}
